import { createAsyncThunk } from '@reduxjs/toolkit';
import mainPageRepository from 'modules/main/domain/repositories/main-page.repository';
import type { StatisticResponseDto } from 'modules/main/domain/types/response-dto';
import { RootState } from 'store/store';

const PREFIX = 'mainPage';

export const fetchMainPageInfo = createAsyncThunk<StatisticResponseDto, { tournamentId: number }>(
  `${PREFIX}/fetchChampionships`,
  async (payload, { rejectWithValue }) => {
    try {
      return await mainPageRepository.getStatistics(payload.tournamentId);
    } catch (error) {
      console.error(`${PREFIX}/fetchChampionships error:`, error);

      let message;
      if (error instanceof Error) {
        message = error.message;
      } else {
        message = String(error);
      }
      return rejectWithValue(message);
    }
  },
  {
    condition: (_, { getState }) => {
      // защита только от параллельных запросов — данные обновляются при каждом заходе на дашборд
      const { status } = (getState() as RootState).mainPage;
      return !status.loading && !status.refreshing;
    },
  },
);
